export default {
    name: 'accountservice',
    dependencies: ['xhrservice', 'userservice', 'radio'],
    callable(xhr, userservice, radio) {
        let isReady = false;
        let personalContentData = null;
        let personalContentPromise;

        init();

        function init() {
            radio(userservice.DATA_READY).subscribe(
                fetchPersonalContantPromise
            );
            fetchPersonalContantPromise();
        }

        function fetchPersonalContantPromise() {
            personalContentPromise = userservice.getAccountData().then(e => {
                personalContentData = e;
                isReady = true;
                return e;
            });
        }

        function throwIfNotReady() {
            if (!isReady) {
                throw new Error('Personal content not ready');
            }
        }

        function getUserEmail() {
            throwIfNotReady();
            if (
                personalContentData &&
                personalContentData.userInfo &&
                personalContentData.userInfo.email
            ) {
                return personalContentData.userInfo.email;
            }
            return null;
        }

        return {
            isReady() {
                return isReady;
            },
            whenReady() {
                return personalContentPromise;
            },
            isLoggedIn() {
                throwIfNotReady();
                return personalContentData.loggedIn;
            },
            getUserEmail,
        };
    },
};



// WEBPACK FOOTER //
// ./services/accountservice.js